<div style="height:calc(100vh - 235px);">
    <dx-data-grid #commandsGrid
                  height="100%"
                  hoverStateEnabled="true"
                  [columnAutoWidth]="true"
                  [dataSource]="dataSource"
                  [errorRowEnabled]="false"
                  [focusedRowEnabled]="true"
                  [wordWrapEnabled]="false"
                  (onRowDblClick)="onRowDblClick($event)">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate" />
        <dxo-header-filter [visible]="true" />
        <dxo-paging [enabled]="false" />
        <dxo-scrolling showScrollbar="always" />
        <dxo-summary>
            <dxi-total-item column="command" [displayFormat]="'localAgentsCommands.lblCommandsCount' | translate" summaryType="count" />
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="onRefreshButtonClick()" />
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-date-range-box applyValueMode="useButtons"
                                       displayFormat="MMMM d, yyyy"
                                       labelMode="hidden"
                                       width="320"
                                       [max]="maxDate"
                                       [(value)]="selectedDates"
                                       (onValueChanged)="onDatesChanged()" />
                </div>
            </dxi-item>
            <dxi-item name="searchPanel" />
        </dxo-toolbar>

        <dxi-column dataField="command" 
                    [calculateCellValue]="displayCommand"
                    [caption]="'localAgentsCommands.lblCommand' | translate" />
        <dxi-column dataField="status" 
                    [calculateCellValue]="displayStatus"
                    [caption]="'localAgentsCommands.lblStatus' | translate" />
        <dxi-column dataField="localAgent.name" 
                    [caption]="'_commons.agent' | translate"/>
        <dxi-column dataField="requestedByUser.displayName" 
                    [calculateCellValue]="displayName"
                    [caption]="'localAgentsCommands.lblRequestedBy' | translate" />
        <dxi-column dataField="createdOn"  
                    dataType="datetime"
                    format="MMMM d, yyyy HH:mm:ss"
                    [caption]="'localAgentsCommands.lblCreatedOnUtc' | translate"/>
        <dxi-column dataField="startedOn" 
                    dataType="datetime"
                    format="MMMM d, yyyy HH:mm:ss"
                    [caption]="'localAgentsCommands.lblStartedOnUtc' | translate" />
        <dxi-column dataField="completedOn" 
                    dataType="datetime"
                    format="MMMM d, yyyy HH:mm:ss"
                    [caption]="'localAgentsCommands.lblCompletedOnUtc' | translate" />
    </dx-data-grid>
</div>

<!-- Display popup -->
<app-local-agent-command #commandDetailsPopup/>